<script lang="ts">
import EventEditor from "@/Components/EventEditor.vue";
import MainPage from "@/Components/MainPage.vue";
import Authenticated from "@/Layouts/AuthenticatedSchool.vue";
import { Event, EventTypes } from "@/Types/event";
import axios from "axios";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "CreateEventVue",
    components: {
        MainPage,
        EventEditor,
    },
    layout: Authenticated,
    props: {
        eventTypes: {
            type: Array as PropType<EventTypes>,
            required: true,
        },
    },
    methods: {
        submit(data: Event, clbk: () => void, preserveState: boolean): void {
            axios
                .post(route("school.events.store"), data)
                .then(() => {
                    if (!preserveState) this.$inertia.visit(route("school.dashboard"), { preserveState: false });
                })
                .finally(() => {
                    if (clbk) clbk();
                });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('acp.event_create')" :gap="true">
        <EventEditor :event-types="eventTypes" :create="true" :emit-actions="true" @submit="submit" />
    </MainPage>
</template>
